module.exports = __webpack_public_path__ + "static/media/card2_2.4d9d67be.png";